module.exports = __webpack_public_path__ + "img/bg.9a3b146d.png";